import type { ServerError, ServerParseError } from '@apollo/client';

/** Returns whether an error has a status code in it. */
export function isServerStatusError(
  networkError: Error | ServerError | ServerParseError | undefined | null
): networkError is ServerError | ServerParseError {
  return Boolean(networkError && 'statusCode' in networkError);
}
